import * as z from "zod"
import { LineItemType, CostUnitType, SurchargeUnit } from "@prisma/client"

export const LineItemModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  label: z.string(),
  description: z.string().nullish(),
  type: z.nativeEnum(LineItemType).nullish(),
  cost: z.number().int(),
  is_per_unit: z.boolean(),
  per_unit_cost: z.number().int().nullish(),
  per_unit_cost_type: z.nativeEnum(CostUnitType),
  per_unit_count: z.number().nullish(),
  per_unit_count_type: z.nativeEnum(SurchargeUnit),
  quote_variant_id: z.number().int(),
  quote_id: z.number().int().nullish(),
  request_id: z.number().int().nullish(),
  issued_by_rate_id: z.number().int().nullish(),
  issued_by_tiered_cost_id: z.number().int().nullish(),
  issued_by_surcharge_id: z.number().int().nullish(),
  issued_by_markup_id: z.number().int().nullish(),
  disassociated_at: z.date().nullish(),
  parent_id: z.number().int().nullish(),
  integration_id: z.string().nullish(),
})
